module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Anzahl " + _vm._s(_vm.bezMitglieder))]), _vm._v(" "), (_vm.kontaktGruppen.length < 5) ? _c('v-row', {
    staticClass: "text-center"
  }, [_vm._l((_vm.kontaktGruppen), function(item, index) {
    return (index > 0) ? _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": _vm.mdsize
      }
    }, [_c('h1', [_vm._v(_vm._s(item.count))]), _vm._v("\n        " + _vm._s(item.value) + "\n      ")]) : _vm._e()
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.kontaktGruppen[0].count))]), _vm._v(_vm._s(_vm.bezMitglieder))])], 2) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_vm._l((_vm.kontaktGruppen), function(item, index) {
    return (index > 0) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.count))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.kontaktGruppen[0].count))]), _vm._v(_vm._s(_vm.bezMitglieder) + "\n              ")])])], 2)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cdac574"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/ripuaren.vue
// module id = 802
// module chunks = 15